export default __webpack_public_path__ + "img/chamedoon.50ece509.png";